/** Create a new ID with a given Brand */
export const createID = () => (Math.random() * 10000000000000).toString();
/** Create a fixed ID (passed as parameter). Useful in snapshot testing */
export const createFixedID = (id) => id;
//# sourceMappingURL=createID.js.map